export default __webpack_public_path__ + "static/media/01_jelen_info-min.7a2db653.jpg";